import { Action, Dispatch } from 'redux';
import { monitoringAlertInternalApi } from '../apis';
import { fetchAlertsSuccess, updateAlertSuccess } from './alertReducer';
import { InternalApiEntityType, InternalApiScenarioType, InternalApiSortDirection } from '../api-internal';

export const fetchAlerts =
  (
    page: number,
    size: number,
    personId?: string,
    statuses?: string[],
    scenarioTypes?: InternalApiScenarioType[],
    activeAssigneeId?: string,
    reason?: string | undefined,
    scenarioIds?: string | undefined,
    query?: string | undefined,
    orderBy?: string,
    direction?: InternalApiSortDirection,
    entityType?: InternalApiEntityType
  ) =>
  async (dispatch: Dispatch): Promise<Action> => {
    const alerts = await monitoringAlertInternalApi.findAllAlertsInternal({
      page,
      size,
      personId,
      scenarioTypes,
      activeAssigneeId,
      query,
      orderBy,
      direction,
      scenarioIds,
      entityType,
      statuses,
      reason,
    });
    return dispatch(fetchAlertsSuccess(alerts));
  };

export const fetchUpdatedAlert =
  (alertId: number) =>
  async (dispatch: Dispatch): Promise<Action> => {
    const alert = await monitoringAlertInternalApi.getAlertInternal({ alertId });
    return dispatch(updateAlertSuccess(alert));
  };
